export default class NetworkMatchingRemovedSerializer {
  static serialize(data) {
    const payload = {
      ...data,
      userId: data.userId,
      carrierId: data.carrierId,
      orderId: data.orderId,
      dateRemoved: data.dateRemoved,
      tractorCity: data.carrierOriginCity,
      tractorState: data.carrierOriginState,
      carrierName: data.carrierName,
      movementId: data.movementId,
      milesFromOrigin: data.milesFromOrigin
    };

    const customProperties = [];
    customProperties.forEach(prop => delete payload[prop]);   
    return payload;
  }

  static deSerialize(data) {
    return {
      ...data,
      userId: data.userId,
      carrierId: data.carrierId,
      orderId: data.orderId,
      dateRemoved: data.dateRemoved
    };
  }
}